export const ALL_PLACES = {

  // 🌎 WORLD MAP (countries)
world: [
    { id: "afghanistan", name: "Afghanistan" },
    { id: "albania", name: "Albania" },
    { id: "algeria", name: "Algeria" }, // FIXED: was "alegria"
    { id: "andorra", name: "Andorra" }, // MISSING? (optional)
    { id: "angola", name: "Angola" },
    { id: "americansamoa", name: "American Samoa", displayName: "American Samoa" },
  { id: "anguilla", name: "Anguilla" },
    { id: "antiguaandbarbuda", name: "Antigua and Barbuda" }, // duplicate removed
    { id: "argentina", name: "Argentina" },
    { id: "armenia", name: "Armenia" },
    { id: "aruba", name: "Aruba" },
    { id: "australia", name: "Australia" },
    { id: "austria", name: "Austria" }, // MISSING? (optional)
    { id: "azerbaijan", name: "Azerbaijan" },

    { id: "bahamas", name: "Bahamas" },
    { id: "bahrain", name: "Bahrain" },
    { id: "bangladesh", name: "Bangladesh" },
    { id: "barbados", name: "Barbados" },
    { id: "belarus", name: "Belarus" },
    { id: "belgium", name: "Belgium" },
    { id: "belize", name: "Belize" },
    { id: "benin", name: "Benin" },
    { id: "bermuda", name: "Bermuda" },
    { id: "bhutan", name: "Bhutan" },
    { id: "bolivia", name: "Bolivia" },
    { id: "bosniaandherzegovina", name: "Bosnia and Herzegovina" },
    { id: "botswana", name: "Botswana" },
    { id: "brazil", name: "Brazil" },
    { id: "britishvirginislands", name: "British Virgin Islands" }, // territory
    { id: "bruneidarussalam", name: "Brunei Darussalam" },
    { id: "bulgaria", name: "Bulgaria" },
    { id: "burkinafaso", name: "Burkina Faso" },
    { id: "burundi", name: "Burundi" },

    { id: "cambodia", name: "Cambodia" },
    { id: "cameroon", name: "Cameroon" },
    { id: "canada", name: "Canada" },
    { id: "capeverde", name: "Cape Verde" },
    { id: "caymanislands", name: "Cayman Islands" },
    { id: "centralafricanrepublic", name: "Central African Republic" },
    { id: "chad", name: "Chad" },
    { id: "chile", name: "Chile" },
    { id: "china", name: "China" },
    { id: "colombia", name: "Colombia" },
    { id: "comoros", name: "Comoros" },
    { id: "democraticrepublicofthecongo", name: "Democratic Republic of the Congo" }, 
    { id: "congo", name: "Congo" },
    { id: "costarica", name: "Costa Rica" },
    { id: "cotedivore", name: "Côte d'Ivoire" },
    { id: "croatia", name: "Croatia" },
    { id: "cuba", name: "Cuba" },
    { id: "curacao", name: "Curaçao" },
    { id: "cyprus", name: "Cyprus" },
    { id: "czechrepublic", name: "Czech Republic" },

    { id: "denmark", name: "Denmark" },
    { id: "djibouti", name: "Djibouti" }, // FIXED: was "dijibouti"
    { id: "dominica", name: "Dominica" },
    { id: "dominicanrepublic", name: "Dominican Republic" },

    { id: "ecuador", name: "Ecuador" },
    { id: "egypt", name: "Egypt" },
    { id: "elsalvador", name: "El Salvador" },
    { id: "equatorialguinea", name: "Equatorial Guinea" },
    { id: "eritrea", name: "Eritrea" },
    { id: "estonia", name: "Estonia" },
    { id: "eswatini", name: "Eswatini" }, // FIX: was "swaziland"
    { id: "ethiopia", name: "Ethiopia" },

    { id: "falklandislands", name: "Falkland Islands" },
    { id: "faeroeisland", name: "Faeroe Island" },
    { id: "federatedstatesofmicronesia", name: "Federated States of Micronesia" },
    { id: "fiji", name: "Fiji" },
    { id: "finland", name: "Finland" }, // FIXED: was "findland"
    { id: "france", name: "France" },
    { id: "frenchguiana", name: "French Guiana" }, // territory
    { id: "frenchpolynesia", name: "French Polynesia" }, // territory

    { id: "gabon", name: "Gabon" },
    { id: "gambia", name: "The Gambia" }, // FIXED: was "thegambia"
    { id: "georgiaco", name: "Georgia (Country)", displayName: "Georgia (Country)" },
    { id: "germany", name: "Germany" },
    { id: "ghana", name: "Ghana" },
    { id: "greece", name: "Greece" },
    { id: "greenland", name: "Greenland" }, // territory
    { id: "grenada", name: "Grenada" },
    { id: "guadeloupe", name: "Guadeloupe" }, // territory, duplicate removed
    { id: "guam", name: "Guam" }, // territory
    { id: "guatemala", name: "Guatemala" },
    { id: "guinea", name: "Guinea" },
    { id: "guyana", name: "Guyana" },
    { id: "guineabissau", name: "Guinea-Bissau" },

    { id: "haiti", name: "Haiti" },
    { id: "honduras", name: "Honduras" },
    { id: "hungary", name: "Hungary" },

    { id: "iceland", name: "Iceland" },
    { id: "india", name: "India" },
    { id: "indonesia", name: "Indonesia" },
    { id: "iran", name: "Iran" },
    { id: "iraq", name: "Iraq" },
    { id: "ireland", name: "Ireland" },
    { id: "israel", name: "Israel" },
    { id: "italy", name: "Italy" },

    { id: "jamaica", name: "Jamaica" },
    { id: "japan", name: "Japan" },
    { id: "jordan", name: "Jordan" },

    { id: "kazakhstan", name: "Kazakhstan" },
    { id: "kenya", name: "Kenya" },
    { id: "kiribati", name: "Kiribati" }, // MISSING? optional
    { id: "kosovo", name: "Kosovo" },
    { id: "kuwait", name: "Kuwait" },
    { id: "kyrgyzstan", name: "Kyrgyzstan" },

    { id: "laopdr", name: "Lao PDR" },
    { id: "latvia", name: "Latvia" },
    { id: "lebanon", name: "Lebanon" },
    { id: "lesotho", name: "Lesotho" },
    { id: "liberia", name: "Liberia" },
    { id: "libya", name: "Libya" },
    { id: "liechtenstein", name: "Liechtenstein" }, // optional
    { id: "lithuania", name: "Lithuania" },
    { id: "luxembourg", name: "Luxembourg" },

    { id: "madagascar", name: "Madagascar" },
    { id: "malawi", name: "Malawi" },
    { id: "malaysia", name: "Malaysia" },
    { id: "maldives", name: "Maldives" },
    { id: "mali", name: "Mali" },
    { id: "malta", name: "Malta" },
    { id: "marshallislands", name: "Marshall Islands" },
    { id: "martinique", name: "Martinique" }, // territory
    { id: "mauritania", name: "Mauritania" },
    { id: "mauritius", name: "Mauritius" },
    { id: "mayotte", name: "Mayotte" }, // territory
    { id: "mexico", name: "Mexico" },
    { id: "moldova", name: "Moldova" },
    { id: "monaco", name: "Monaco" }, // optional
    { id: "mongolia", name: "Mongolia" },
    { id: "montenegro", name: "Montenegro" },
    { id: "montserrat", name: "Montserrat" }, // territory
    { id: "morocco", name: "Morocco" },
    { id: "mozambique", name: "Mozambique" },
    { id: "myanmar", name: "Myanmar" },

    { id: "namibia", name: "Namibia" },
    { id: "nauru", name: "Nauru" },
    { id: "nepal", name: "Nepal" },
    { id: "netherlands", name: "Netherlands" },
    { id: "newcaledonia", name: "New Caledonia" }, // territory
    { id: "newzealand", name: "New Zealand" },
    { id: "nicaragua", name: "Nicaragua" },
    { id: "niger", name: "Niger" },
    { id: "nigeria", name: "Nigeria" },
    { id: "northkorea", name: "Democratic Republic of Korea" }, // FIX: normalized
    { id: "northmacedonia", name: "North Macedonia" }, // FIX: was "macedonia"
    { id: "norway", name: "Norway" },
    { id: "northernmarianaislands", name: "Northern Mariana Islands" }, // territory

    { id: "oman", name: "Oman" },

    { id: "pakistan", name: "Pakistan" },
    { id: "palau", name: "Palau" },
    { id: "palestine", name: "Palestine" },
    { id: "panama", name: "Panama" },
    { id: "papuanewguinea", name: "Papua New Guinea" },
    { id: "paraguay", name: "Paraguay" },
    { id: "peru", name: "Peru" },
    { id: "philippines", name: "Philippines" },
    { id: "poland", name: "Poland" },
    { id: "portugal", name: "Portugal" },

    { id: "qatar", name: "Qatar" },

    { id: "romania", name: "Romania" },
    { id: "russianfederation", name: "Russian Federation" },
    { id: "rwanda", name: "Rwanda" },

    { id: "saba", name: "Saba" }, // territory
    { id: "saintbarthelemy", name: "Saint-Barthélemy" },
    { id: "saintkittsandnevis", name: "Saint Kitts and Nevis" },
    { id: "saintlucia", name: "Saint Lucia" },
    { id: "saintmartin", name: "Saint Martin" },
    { id: "saintvincentandthegrenadines", name: "Saint Vincent and the Grenadines" },
    { id: "samoa", name: "Samoa" },
    { id: "sanmarino", name: "San Marino" }, // optional
    { id: "saotomeandprincipe", name: "São Tomé and Principe" },
    { id: "saudiarabia", name: "Saudi Arabia" },
    { id: "senegal", name: "Senegal" },
    { id: "serbia", name: "Serbia" }, // optional
    { id: "seychelles", name: "Seychelles" },
    { id: "sierraleone", name: "Sierra Leone" },
    { id: "singapore", name: "Singapore" }, // optional
    { id: "slovakia", name: "Slovakia" },
    { id: "slovenia", name: "Slovenia" },
    { id: "solomonislands", name: "Solomon Islands" },
    { id: "somalia", name: "Somalia" },
    { id: "southafrica", name: "South Africa" },
    { id: "southkorea", name: "Republic of Korea" }, // FIX: normalized
    { id: "southsudan", name: "South Sudan" },
    { id: "spain", name: "Spain" },
    { id: "srilanka", name: "Sri Lanka" },
    { id: "steustatius", name: "St. Eustatius" }, // territory
    { id: "sudan", name: "Sudan" },
    { id: "suriname", name: "Suriname" },
    { id: "sweden", name: "Sweden" }, // optional
    { id: "switzerland", name: "Switzerland" },
    { id: "syria", name: "Syria" },

    { id: "taiwan", name: "Taiwan" },
    { id: "tajikistan", name: "Tajikistan" },
    { id: "tanzania", name: "Tanzania" },
    { id: "thailand", name: "Thailand" },
    { id: "timorleste", name: "Timor-Leste" },
    { id: "togo", name: "Togo" },
    { id: "tonga", name: "Tonga" },
    { id: "trinidadandtobago", name: "Trinidad and Tobago" },
    { id: "tunisia", name: "Tunisia" },
    { id: "turkey", name: "Turkey" },
    { id: "turkmenistan", name: "Turkmenistan" },
    { id: "turksandcaicosislands", name: "Turks and Caicos Islands" }, // FIX: plural

    { id: "tuvalu", name: "Tuvalu" },

    { id: "uganda", name: "Uganda" },
    { id: "ukraine", name: "Ukraine" },
    { id: "unitedarabemirates", name: "United Arab Emirates" },
    { id: "unitedkingdom", name: "United Kingdom" }, // FIX: was "unitedkindom"
    { id: "unitedstatesvirginislands", name: "United States Virgin Islands" }, // territory
    { id: "uruguay", name: "Uruguay" },
    { id: "uzbekistan", name: "Uzbekistan" },

    { id: "vanuatu", name: "Vanuatu" },
    { id: "venezuela", name: "Venezuela" },
    { id: "vietnam", name: "Vietnam" },

    { id: "westernsahara", name: "Western Sahara" },

    { id: "yemen", name: "Yemen" },

    { id: "zambia", name: "Zambia" },
    { id: "zimbabwe", name: "Zimbabwe" },
    { id: "unitedstates", name: "United States" },
    { id: "puertorico", name: "Puerto Rico" },
]
,

  // 🇵🇷 PUERTO RICO MUNICIPALITIES
  puertorico: [
    { id: "yauco", name: "Yauco" },
{ id: "yabucoa", name: "Yabucoa" },
{ id: "villalba", name: "Villalba" },
{ id: "vieques", name: "Vieques" },
{ id: "vegabaja", name: "Vega Baja" },
{ id: "vegaalta", name: "Vega Alta" },
{ id: "utuado", name: "Utuado" },
{ id: "trujilloalto", name: "Trujillo Alto" },
{ id: "toabaja", name: "Toa Baja" },
{ id: "toaalta", name: "Toa Alta" },
{ id: "santaisabel", name: "Santa Isabel" },
{ id: "sansebastian", name: "San Sebastián" },
{ id: "sanlorenzo", name: "San Lorenzo" },
{ id: "sanjuan", name: "San Juan" },
{ id: "sangerman", name: "San Germán" },
{ id: "salinas", name: "Salinas" },
{ id: "sabanagrande", name: "Sabana Grande" },
{ id: "riogrande", name: "Rio Grande" },
{ id: "rincon", name: "Rincón" },
{ id: "quebradillas", name: "Quebradillas" },
{ id: "ponce", name: "Ponce" },
{ id: "penuelas", name: "Peñuelas" },
{ id: "patillas", name: "Patillas" },
{ id: "orocovis", name: "Orocovis" },
{ id: "naranjito", name: "Naranjito" },
{ id: "naguabo", name: "Naguabo" },
{ id: "morovis", name: "Morovis" },
{ id: "moca", name: "Moca" },
{ id: "mayaguez", name: "Mayagüez" },
{ id: "maunabo", name: "Maunabo" },
{ id: "maricao", name: "Maricao" },
{ id: "manati", name: "Manatí" },
{ id: "luquillo", name: "Luquillo" },
{ id: "loiza", name: "Loiza" },
{ id: "laspiedras", name: "Las Piedras" },
{ id: "lasmarias", name: "Las Marias" },
{ id: "lares", name: "Lares" },
{ id: "lajas", name: "Lajas" },
{ id: "juncos", name: "Juncos" },
{ id: "juanadiaz", name: "Juana Díaz" },
{ id: "jayuya", name: "Jayuya" },
{ id: "isabela", name: "Isabela" },
{ id: "humacao", name: "Humacao" },
{ id: "hormigueros", name: "Hormigueros" },
{ id: "hatillo", name: "Hatillo" },
{ id: "gurabo", name: "Gurabo" },
{ id: "guaynabo", name: "Guaynabo" },
{ id: "guayanilla", name: "Guayanilla" },
{ id: "guayama", name: "Guayama" },
{ id: "guanica", name: "Guánica" },
{ id: "floridapr", name: "Florida, Puerto Rico", displayName: "Florida, Puerto Rico" },
{ id: "fajardo", name: "Fajardo" },
{ id: "dorado", name: "Dorado" },
{ id: "culebra", name: "Culebra" },
{ id: "corozal", name: "Corozal" },
{ id: "comerio", name: "Comerío" },
{ id: "coamo", name: "Coamo" },
{ id: "cidra", name: "Cidra" },
{ id: "ciales", name: "Ciales" },
{ id: "ceiba", name: "Ceiba" },
{ id: "cayey", name: "Cayey" },
{ id: "catano", name: "Cataño" },
{ id: "carolina", name: "Carolina" },
{ id: "canovanas", name: "Canovanas" },
{ id: "camuy", name: "Camuy" },
{ id: "caguas", name: "Caguas" },
{ id: "caborojo", name: "Cabo Rojo" },
{ id: "bayamon", name: "Bayamón" },
{ id: "barranquitas", name: "Barranquitas" },   // ⭐ FIXED
{ id: "barceloneta", name: "Barceloneta" },
{ id: "arroyo", name: "Arroyo" },
{ id: "arecibo", name: "Arecibo" },
{ id: "anasco", name: "Añasco" },
{ id: "aibonito", name: "Aibonito" },
{ id: "aguasbuenas", name: "Aguas Buenas" },
{ id: "aguadilla", name: "Aguadilla" },
{ id: "aguada", name: "Aguada" },
{ id: "adjuntas", name: "Adjuntas" },




  ],

  // 🇺🇸 UNITED STATES
  usa: [
    { id: "massachusetts", name: "Massachusetts" },
    { id: "minnesota", name: "Minnesota" },
    { id: "montana", name: "Montana" },
    { id: "northdakota", name: "North Dakota" },
    { id: "hawaii", name: "Hawaii" },
    { id: "idaho", name: "Idaho" },
    { id: "washington", name: "Washington" },
    { id: "arizona", name: "Arizona" },
    { id: "california", name: "California" },
    { id: "colorado", name: "Colorado" },
        { id: "grandlake", name: "Grand Lake" },
        { id: "aspen", name: "Aspen" },
        { id: "buena vista", name: "Buena Vista" },
        { id: "canyon city", name: "Canyon City" },
        { id: "colorado springs", name: "Colorado Springs" },
        { id: "frisco", name: "Frisco" },
        { id: "georgetown", name: "Georgetown" },
        { id: "breckenridge", name: "Breckenridge" },
        { id: "golden", name: "Golden" },
        { id: "glenwood springs", name: "Glenwood Springs" },
        { id: "morrison", name: "Morrison" },
        { id: "mosca", name: "Mosca" },
        { id: "ouray", name: "Ouray" },
        { id: "rifle", name: "Rifle" },
        { id: "steamboat springs", name: "Steamboat Springs" },
        { id: "telluride", name: "Telluride" },
        { id: "vail", name: "Vail" },
        { id: "manitou springs", name: "Manitou Springs" },
        { id: "denver", name: "Denver" },
    { id: "nevada", name: "Nevada" },
    { id: "newmexico", name: "New Mexico" },
    { id: "oregoncoast", name: "Oregon Coast" },
    { id: "oregoncolumbiariver", name: "Oregon Columbia River" },
    { id: "oregonsilverfalls", name: "Oregon Silver Falls" },
    { id: "utah", name: "Utah" },
    { id: "wyoming", name: "Wyoming" },
    { id: "arkansas", name: "Arkansas" },
    { id: "iowa", name: "Iowa" },
    { id: "kansas", name: "Kansas" },
    { id: "missouri", name: "Missouri" },
    { id: "nebraska", name: "Nebraska" },
    { id: "oklahoma", name: "Oklahoma" },
    { id: "southdakota", name: "South Dakota" },
    { id: "louisiana", name: "Louisiana" },
    { id: "texas", name: "Texas" },
    { id: "connecticut", name: "Connecticut" },
    { id: "newhampshire", name: "New Hampshire" },
    { id: "rhodeisland", name: "Rhode Island" },
    { id: "vermont", name: "Vermont" },
    { id: "alabama", name: "Alabama" },
    { id: "floridaus", name: "Florida, USA", displayName: "Florida, USA" },
    { id: "georgiaus", name: "Georgia, USA", displayName: "Georgia (USA)" },
    { id: "mississippi", name: "Mississippi" },
    { id: "southcarolina", name: "South Carolina" },
    { id: "illinois", name: "Illinois" },
    { id: "indiana", name: "Indiana" },
    { id: "kentucky", name: "Kentucky" },
    { id: "northcarolina", name: "North Carolina" },
    { id: "ohio", name: "Ohio" },
    { id: "tennessee", name: "Tennessee" },
    { id: "virginia", name: "Virginia" },
    { id: "wisconsin", name: "Wisconsin" },
    { id: "westvirginia", name: "West Virginia" },
    { id: "delaware", name: "Delaware" },
    { id: "dc", name: "DC" },
    { id: "maryland", name: "Maryland" },
    { id: "newjersey", name: "New Jersey" },
    { id: "newyork", name: "New York" },
    { id: "pennsylvania", name: "Pennsylvania" },
    { id: "maine", name: "Maine" },
    { id: "michigan", name: "Michigan" },
    { id: "alaska", name: "Alaska" },
     { id: "borinquen", name: "Borinquen"},
   
     
    


  ]
};
